// extracted by mini-css-extract-plugin
module.exports = {"showMoreLink":"_2uzem","root":"_3I6qa","title":"_14_Kd","categoryList":"_2L0kd","category":"_3IRvs","categoryLink":"_1HkBT","showMore":"_1tg9A"};